import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Icon } from '../icon/icon.component.js';
import { ColorsForMode } from '../button/button.style.js';
import { StyledButton } from './icon-button.style.js';

const IconButton = props => {
    const { className = '', disabled, icon, margin, onClick, path, type = 'button', mode = 'default', size = 'small' } = props, rest = __rest(props, ["className", "disabled", "icon", "margin", "onClick", "path", "type", "mode", "size"]);
    const { color: iconColor } = ColorsForMode[mode];
    return (jsx(StyledButton, Object.assign({ className: className, disabled: disabled, margin: margin, onClick: onClick, type: type, size: size, mode: mode }, rest, { children: jsx(Icon, { icon: icon, path: path, color: iconColor }, void 0) }), void 0));
};

export { IconButton };
